export default __webpack_public_path__ + "static/jeff hamilton-3d3e760f554551b92a6ecfef8ac5c755.png";